"use client";

import { verboseDatetimeFormat } from "@/service/date/article";
import { Paywall } from "@/components/common/paywall";
import { useState } from "react";

import { ResourceSurvey } from "@/components/common/resource-survey/resource-survey";
import { ResourceRating } from "@/components/common/resource-rating";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { videoCardBadgeStyles } from "@/components/video/video-card/service";

export const VideoMeta = ({
  publishedAt,
  productAccess,
  rating,
  id,
  survey,
  product,
  title,
  episodeNumber,
}: {
  publishedAt: DateString;
  productAccess: any;
  rating: RatingVM;
  id: number;
  survey: SurveyVM;
  product: ProductPriceOneVariantVM | null | undefined;
  title: string;
  episodeNumber?: number;
}) => {
  const [showSurvey, setShowSurvey] = useState<boolean>(
    survey?.canAnswer && rating.yourVote !== null,
  );

  return (
    <>
      <div className={"mt-8"}></div>
      {!product && (
        <header
          className={
            "@704:flex-row @704:justify-between @704:items-center mb-4 flex flex-col gap-4"
          }
        >
          <h1 className={"text-2xl font-semibold text-zinc-950"}>{title}</h1>
          <div className={"ml-auto"}>
            <ResourceRating
              rating={rating}
              resourceId={id}
              resourceType={"video"}
              onRate={() => setShowSurvey(true)}
            />
          </div>
        </header>
      )}

      <div className={"mt-2 flex items-center gap-4"}>
        <div className={"text-sm text-zinc-500"}>
          {verboseDatetimeFormat(publishedAt)}
        </div>
        {episodeNumber !== undefined && (
          <Badge
            className={cn(
              videoCardBadgeStyles,
              "bg-remedium-blue static text-white",
            )}
          >
            Odcinek {episodeNumber}
          </Badge>
        )}
      </div>

      {showSurvey && survey && (
        <Paywall>
          <ResourceSurvey
            survey={survey}
            resourceId={id}
            resourceType={"video"}
            title={title}
          />
        </Paywall>
      )}
    </>
  );
};
